<template>
    <div>
        <div class="row py-3">
            <div class="col-lg-12">
                <label>
                    รายการพัสดุ {{ booking.bookingItems.length }} รายการ
                </label>
            </div>
            <div class="col-lg-12">
                <div class="scroll-table scroll-bar-pop scrollbar-style table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>ลำดับ</th>
                                <th>ข้อมูลผู้รับ</th>
                                <th>ที่อยู่ผู้รับ</th>
                                <th>จัดการ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(item, index) in booking.bookingItems">
                                <tr :key="index">
                                    <td width="8%">{{index + 1}}</td>
                                    <td>
                                        <div>{{item.to.name}}</div>
                                        <div>{{item.to.tel}}</div>
                                    </td>
                                    <td>
                                        <span>
                                            {{ 
                                                [
                                                    item.to.address,
                                                    item.to.state,
                                                    item.to.district,
                                                    item.to.province,
                                                    item.to.postcode,
                                                ].join(' ')
                                            }}
                                        </span>
                                    </td>
                                    <td>
                                        <button 
                                            class="btn btn-link text-danger p-2 hvr-grow" 
                                        >
                                            <i class="far fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="4">
                                        <div :class="['row', calScreenFull ? 'justify-content-center' : '']">
                                            <div class="col-2">
                                                <label floater>
                                                    น้ำหนัก {{ $THEME.unitKG ? '( กิโลกรัม )' : '( กรัม )' }} <small class="text-danger">*</small>
                                                </label>
                                                <input
                                                    step="0.01"
                                                    type="number"
                                                    placeholder="น้ำหนัก"
                                                    class="form-control"
                                                    ref="focusWeight"
                                                    :disabled="false"
                                                    v-model="item.parcel.weight"
                                                    @keyup="checkWeight(item.parcel.weight, index)"
                                                    @blur="checkWeight(item.parcel.weight, index)"
                                                    :class="{ 'is-invalid': $v.booking.bookingItems.$each[index].parcel.weight.$error 
                                                                || (validateWeight[index] ? validateWeight[index].checkWeight.status : false)
                                                            }"
                                                    :onkeydown="$THEME.unitKG ? 'return event.keyCode !== 69 && event.keyCode !== 189' : 'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                                                />
                                                <div
                                                    v-if="!$v.booking.bookingItems.$each[index].parcel.weight.required"
                                                    class="invalid-feedback"
                                                >
                                                    กรุณากรอกน้ำหนัก
                                                </div>
                                                <small 
                                                    v-if="(validateWeight[index])? validateWeight[index].checkWeight.status : false" 
                                                    class="text-danger"
                                                >
                                                    {{validateWeight[index].checkWeight.msg}} 
                                                </small>
                                            </div>
                                            <div :class="[calScreenFull ? 'col-4' : 'col-5']">
                                                <AutoBox
                                                    :listSize="listSize"
                                                    :size="item.parcel.size"
                                                    :weight.sync="item.parcel.weight"
                                                    :weightKG.sync="item.parcel.weightKG" 
                                                    :width.sync="item.parcel.width"
                                                    :length.sync="item.parcel.length" 
                                                    :height.sync="item.parcel.height" 
                                                    :keyBox.sync="item.parcel.key_size"
                                                    courier_key="DEFAULT" 
                                                />
                                            </div>
                                            <div :class="[calScreenFull ? 'col-4' : 'col-5']">
                                                <Dimension
                                                    ref="dimensionParcel"
                                                    :dimension="item.parcel"
                                                    courierCode="DEFAULT"
                                                    :favoriteDimension="false"
                                                    :showLock="false"
                                                />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="4">
                                        <div :class="['row', calScreenFull ? 'justify-content-center' : '']">
                                            <div :class="[calScreenFull ? 'col-5' : 'col-6']">
                                                <label for="input-live">
                                                    เลือกประเภทสินค้า
                                                </label>
                                                <InputParcelType 
                                                    ref="inputParcelType" 
                                                    :data="item.type_parcel"
                                                    :courier="{}"
                                                    :error="checkErrorSeletedParcelInsurance" 
                                                />
                                            </div>
                                            <div :class="['remark-textarea', calScreenFull ? 'col-5' : 'col-6']">
                                                <div class="form-group group-remark">
                                                    <label for="remarkOrderDetail">หมายเหตุ</label>
                                                    <input 
                                                        id="remarkOrderDetail" 
                                                        class="form-control"
                                                        v-model="item.remarkOrderDetail"
                                                    />
                                                    <span class="remark-length">
                                                        {{ item.remarkOrderDetail.length }}  / 100
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AutoBox from '@/components/AutoBox';
import Dimension from '@/components/custom/pos/Dimension';
import InputParcelType from '@/components/custom/pos/InputParcelType'
import { checkWeightRules } from "@/plugins/weightParcel.js"
import {
  required
} from "vuelidate/lib/validators";

export default {
    props:{
        booking: {
            type: Object,
            default: () => {}, 
        },
        listSize: {
            type: Object,
            default: () => {}, 
        },
        showCart: {
            type: String,
            default: ""
        }
    },
    data: () => ({
        validateWeight: [],
    }),
    validations: {
        booking: {
            bookingItems: {
                $each: {
                    parcel: {
                        weight: { required }
                    }
                }
            }
        }
    },
    components:{
        AutoBox,
        Dimension,
        InputParcelType
    },
    mounted(){
        this.setValidate()
    },
    methods:{
        setValidate(){
            for (let [index, val] of this.booking.bookingItems.entries()) {
                this.validateWeight.push({
                    checkWeight:{
                        status:false,
                        msg:""
                    }
                });
            }
        },
        checkWeight(weight , index){
            const { status , msg } = checkWeightRules( "DEFAULT" , weight );
            this.validateWeight[index].checkWeight.status = status
            this.validateWeight[index].checkWeight.msg = msg
        },
    },
    computed:{
        calScreenFull(){
            return this.showCart === '';
        },
        checkErrorSeletedParcelInsurance() {
            let res = {
                status: false,
                data: []
            }
            // if (this.insurance.isCheck && this.$v.insurance.remark.$error && this.submitAddShipping) {
            //     res.data.push('กรุณาเลือกประเภทสินค้า')
            // } else {
            //     res.status = false
            //     res.data = []
            // }
            return res
        }
    }
}

</script>